import React, { useEffect } from 'react';
import ThankYouConfirmation, {
    redirectFromThankYou,
} from '../../components/forms/questions/ThankYouConfirmation.jsx';
import FormSection from './FormSection.jsx';
import { ConfirmationContext } from '../../lib/ConfirmationContext.js';
import { useNavigate } from 'react-router-dom';
import { conversionTrackSubmitted } from '../lib/ConversionEventTracking.js';
import { handleFormSubmissionResponse } from '~/public/lib/handleFormSubmissionResponse.js';

const FormThankYou = ({ form, sections, formSubmissionResults }) => {
    const isBooking = formSubmissionResults?.events?.length > 0;

    const navigate = useNavigate();

    const thankYouSections = sections.filter(
        s => !!s.section.settings?.thankyou,
    );
    const thankYouSectionData =
        thankYouSections.length > 0 ? thankYouSections[0] : null;

    useEffect(() => {
        const confirmationUrl =
            formSubmissionResults?.submission?.confirmation_url;

        if (!form || !confirmationUrl) {
            return;
        }

        const urlConfirmationUrl = new URL(confirmationUrl);

        if (document.location.pathname !== urlConfirmationUrl.pathname) {
            // We just submitted
            if (!handleFormSubmissionResponse(formSubmissionResults)) {
                navigate(urlConfirmationUrl.pathname);
            }
        }
    }, []);

    let schedulingSettings = {};
    if (isBooking) {
        // Find the settings for the scheduling section
        // TODO, this has a potential bug
        //  if there are multiple scheduling questions
        //  we are not grabbing the one they submitted, we're just grabbing the first one
        for (const s of sections) {
            for (const q of s.questions) {
                if (q.type === 'scheduling' || q.type === 'classscheduling') {
                    schedulingSettings = q.settings;
                }
            }
        }
    }

    return (
        <div className="form-section-container p-6">
            <div className="form-section form-section-current mx-auto">
                <ConfirmationContext.Provider
                    value={{
                        isBooking: isBooking,
                        events: formSubmissionResults?.events,
                        usedGrants: formSubmissionResults?.usedGrants,
                        giftCertificates:
                            formSubmissionResults?.giftCertificates,
                        submission: formSubmissionResults?.submission,
                        schedulingSettings: schedulingSettings,
                    }}
                >
                    {!!thankYouSectionData && (
                        <FormSection
                            section={thankYouSectionData.section}
                            questions={thankYouSectionData.questions}
                            formData={{}}
                            setFormData={() => null}
                        />
                    )}
                    {!thankYouSectionData && (
                        <ThankYouConfirmation isBooking={isBooking} />
                    )}
                </ConfirmationContext.Provider>
            </div>
        </div>
    );
};

export default FormThankYou;
